"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSetupDirectDebitLegacyMutation = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var core_1 = require("../../../core");
var _1 = require(".");
function useSetupDirectDebitLegacyMutation(accountId, onSuccess, onError) {
    var api = core_1.configService.getConfig().api;
    var directDebitSetupEndpoint = "".concat(api.baseUrl, "/pace/payments/v2/").concat(accountId, "/direct-debit/setup");
    var invalidateCache = (0, _1.useInvalidateDirectDebitLegacyQuery)(accountId);
    return (0, ui_tools_1.useReactMutation)(function (data) {
        return core_1.apiService.post({
            responseType: 'json',
            url: directDebitSetupEndpoint,
            body: data,
            headers: {
                'orion-endpoint-version': '2',
            },
        });
    }, {
        onSuccess: function () {
            invalidateCache();
            if (onSuccess) {
                onSuccess();
            }
        },
        onError: function (error) {
            if (onError) {
                onError(error);
            }
        },
    });
}
exports.useSetupDirectDebitLegacyMutation = useSetupDirectDebitLegacyMutation;
